import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("h4", null, "Invoices")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "card-toolbar m-0" })
], -1)
const _hoisted_2 = { class: "card-body pt-0" }
const _hoisted_3 = {
  class: /*#__PURE__*/_normalizeClass(`text-success`)
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`card pt-2 ${_ctx.cardClasses}`)
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Datatable, {
        "table-header": _ctx.tableHeader,
        "table-data": _ctx.orders,
        "rows-per-page": 5,
        "enable-items-per-page-dropdown": false,
        onCurrentChange: _ctx.onCurrentChange,
        onSort: _ctx.onSort,
        loading: _ctx.loading
      }, {
        "cell-id": _withCtx(({ row: order }) => [
          _createTextVNode(_toDisplayString(order.id), 1)
        ]),
        "cell-customer_id": _withCtx(({ row: order }) => [
          _createTextVNode(_toDisplayString(order.customer_id), 1)
        ]),
        "cell-total": _withCtx(({ row: order }) => [
          _createElementVNode("span", _hoisted_3, _toDisplayString(order.total), 1)
        ]),
        "cell-created_at": _withCtx(({ row: order }) => [
          _createTextVNode(_toDisplayString(order.created_at), 1)
        ]),
        _: 1
      }, 8, ["table-header", "table-data", "onCurrentChange", "onSort", "loading"])
    ])
  ], 2))
}